import React from 'react'

import { Section } from '../../..'
import { useProfessors } from '../../../../context'
import { Profile } from '../../../profile'

const ProfessorBio = () => {
  const { activeProfessor, setActiveProfessor } = useProfessors()

  const selectProfessor = () => {
    setActiveProfessor(null)
  }

  console.log(activeProfessor, 'activeProfessor')
  return (
    <Section
      title={`${activeProfessor?.name} ${activeProfessor?.lastname}`}
      childrenClass="full-space-section"
      withBackBtn
    >
      <Profile
        type="professor"
        editedProfile={activeProfessor}
        setEditedProfile={selectProfessor}
      />
    </Section>
  )
}

export default ProfessorBio
